export enum ErrorType {
    Unauthorized = 'Unauthorized',
    ExistingEmail = 'ExistingEmail',
    OrderAlreadyPlaced = 'OrderAlreadyPlaced',
    OrderTooSmall = 'OrderTooSmall',
    ProductUnavailable = 'ProductUnavailable',
    RestaurantMenuClosed = 'RestaurantMenuClosed',
    UnsafeContent = 'UnsafeContent'
}
